// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9f5d03d4","453":"d4180bef"}[chunkId] + ".chunk.js";
};